import { useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { useSearchPage } from '../../forms/hocs/search-page.context'
import { useSearchViewState } from '../../contexts/search-view-state-context'

export const useCheckParamsAndOpenModal = () => {
    const location = useLocation()
    const { setShowSaveThisSearch, setShowSavedSearches, toggleSearchFilter } = useSearchViewState()

    const hasShowSaveSearchParam = useMemo(
        () => new URLSearchParams(location.search).get('showSaveSearch') === 'true',
        [location.search]
    )

    const hasShowSearchFormParam = useMemo(
        () => new URLSearchParams(location.search).get('showSearchForm') === 'true',
        [location.search]
    )

    const hasShowSavedSearchesParam = useMemo(
        () => new URLSearchParams(location.search).get('showSavedSearches') === 'true',
        [location.search]
    )

    const { removeTransientParams } = useSearchPage()

    useEffect(() => {
        if (hasShowSaveSearchParam) {
            setShowSaveThisSearch(true)
            removeTransientParams()
        }
        if (hasShowSearchFormParam) {
            toggleSearchFilter(true)
            removeTransientParams()
        }
        if (hasShowSavedSearchesParam) {
            toggleSearchFilter(true)
            setShowSavedSearches(true)
            removeTransientParams()
        }
    }, [
        hasShowSaveSearchParam,
        hasShowSearchFormParam,
        hasShowSavedSearchesParam,
        location.search,
        setShowSaveThisSearch,
        setShowSavedSearches,
        toggleSearchFilter,
        removeTransientParams,
    ])
}
